import React from 'react';
import Book from 'react-icons/lib/fa/book';
import PropTypes from "prop-types";

import CardContainer from 'react/containers/CardContainer';
import Articles from 'react/views/articles/Articles';
import { getArticles } from 'data/ArticleSelector';
import { getTitleUi } from 'data/TitleInfoSelector';
import { getJsonData } from "data/DataStore";
import BookListEventTypes from 'data/types/BookListEventTypes';

const BookListsContainer = (props) => {
	return (
		<CardContainer
			aboutText="Explore lists containing this book"
			cardModel={getArticles("Grab and Go Book Lists")
				.concat(getArticles("Appeal browse"))
				.concat(getArticles("Genre browse"))
				.concat(getArticles("Recommended Reads"))
				.concat(getArticles("Curated List"))}
			component={Articles}
			countText="Book lists"
			icon={Book}
			iconColor='#1e90ff'
            loggingId={getTitleUi(getJsonData())}
            title="Book lists from NoveList"
			eventType={BookListEventTypes.BOOKLISTS_NAME_CLICKED}
			{...props}
		/>
	);
}

BookListsContainer.propTypes = {
	onNullRender: PropTypes.func
};

export default BookListsContainer;


// WEBPACK FOOTER //
// ./src/react/containers/BookListsContainer.jsx